// -*- Mode: rjsx -*-
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FHMaterialStyles, FH_LOGO_HEIGHT } from "../ui/fh-material-styles.js";

function FancyHandsLogo() {
    const user = useSelector(state =>  state.hud.user);
    const [logoAlt, setLogoAlt] = useState("Fancy Hands");    
    const [logoUrl, setLogoUrl] = useState("/images/logos/fh/pixelogo/01.png");
    const [logoUrlFinal, setLogoUrlFinal] = useState("/images/logos/fh/pixelogo/01.png");    
    const [logoCnt, setLogoCount] = useState(0);
    const classes = FHMaterialStyles();
    const dispatch = useDispatch();
    
    let imageStyle = {};

    const LOGOS = [
        "/images/logos/fh/pixelogo/01.png",
        "/images/logos/fh/pixelogo/02.png",
        "/images/logos/fh/pixelogo/03.png",
        "/images/logos/fh/pixelogo/04.png",
        "/images/logos/fh/pixelogo/05.png",
        "/images/logos/fh/pixelogo/06.png",
        "/images/logos/fh/pixelogo/07.png",
        "/images/logos/fh/pixelogo/08.png",
        "/images/logos/fh/pixelogo/09.png",
        "/images/logos/fh/pixelogo/10.png",
    ];
    
    function click(oneWay, event) {
        let sleep = 25;
        var i = 1;
        
        if(event)
            console.log(event.button);
        let logos = [...LOGOS];
        
        if((oneWay === undefined) || !oneWay) {
            let rev = [...logos];
            rev.reverse();
            logos = [...rev, ...logos.slice(1)];
        }
        
        for(var x = 1; x <= logos.length; ++x, ++i) {
            let url = logos[x - 1];
            setTimeout(() => setLogoUrl(url), sleep * i);
        }


        setTimeout(() => { if(user) { setLogoUrl(user.logo.url); } }, sleep * logos.length);
    }

    
    if(user && user.key) {

        // resize the logo proportionally.
        let n = FH_LOGO_HEIGHT / user.logo.params.height;
        imageStyle.width = user.logo.params.width * n;
        imageStyle.minWidth = user.logo.params.width * n;
        
        if(user.logo.alt != logoAlt)
            setLogoAlt(user.logo.alt);
        // set the right logo
        if(user.logo.url != logoUrlFinal) {
            setLogoUrlFinal(user.logo.url);
            click(true);
        }
    }

	return (
		<img
          id="main-logo"
          src={logoUrl}
          title={logoAlt}
          alt={logoAlt}
          className={classes.adminLogoStyle}
          style={imageStyle}
          onClick={(e) => click(false, e) }
        />
	);
}



export default FancyHandsLogo;
